/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useFeatureFlag } from '@/features/globalConfig';
import { useProductDetails } from '@/features/product/api/getProductDetails';
import { useSingleReviewStatistic } from '@/features/customReviews/api/getReviewStatistics';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import Script from 'next/script';

export function BazaarVoicePixel() {
  const { data: productDetailsData } = useProductDetails();
  const product = productDetailsData?.product;
  const skuNumber = product?.itemId ?? '';
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const desktopScriptSource = useFeatureFlag('RR_AZRWEB_PDP_TAG');
  const mobileScriptSource = useFeatureFlag('RR_AZRMOB_PDP_TAG');

  const scriptSource = isDesktop ? desktopScriptSource : mobileScriptSource;
  const { data: reviewStatistic } = useSingleReviewStatistic({
    skuNumber,
    enabled: !!skuNumber,
  });

  const pageViewData = {
    bvProduct: 'RatingsAndReviews',
    productId: skuNumber,
    brand: product?.brandName,
    type: 'Product',
    categoryId: product?.categoryId,
    rootCategoryId: product?.partTypeName,
    numReviews: product?.reviewCount,
    avgRating: product?.averageRating,
    percentRecommended: reviewStatistic?.recommendPercentage,
  };

  const inViewData = {
    productId: product?.itemId,
    bvProduct: 'RatingsAndReviews',
    brand: product?.brandName,
  };

  const handleScriptLoad = () => {
    BV.pixel.trackPageView(pageViewData);

    const containerConfig = {
      minPixels: 100,
      containerId: 'custom-reviews-container',
    };

    BV.pixel.trackInView(inViewData, containerConfig);
    BV.pixel.trackViewedCGC(inViewData, {
      ...containerConfig,
      minTime: 100,
    });
  };

  return <Script src={scriptSource} strategy="afterInteractive" onLoad={handleScriptLoad} />;
}
